import { ObjectType, RecordType } from '@xbcb/shared-types';
// TODO we can obviate the need for deleting ui-only fields by extending the functionality of antd's Form.Item component
// Here is the desired API: <Form.Item uiOnly {...otherProps} />
import { transformParty } from './party';
import { transformProduct } from './product';
import { transformShipment } from './shipment';
import { transformAssignmentTeam } from './assignmentTeam';
import {
  transformUsIsf,
  transformUsConsumptionEntry,
  transformUsIorContinuousBondRequest,
  transformUsInBond,
  transformDeliveryOrder,
} from './workOrder/index';
import { transformUser } from './user';
import { transformInvoice } from './invoice';
import { transformInvoiceLines } from './invoiceLines';
import { transformReportReconciliationRequest } from './reportReconciliationRequest';
import { transformSubjectMatterExpertTeam } from './subjectMatterExpertTeam';
import { transformBulkUploadRequest } from './bulkUploadRequest';
import { transformBusinessSupportTeam } from './businessSupportTeam';
import { transformExchangeMessage } from './exchangeMessage';
export * from './party';
export * from './product';
export * from './shipment';
export * from './workOrder/index';
export * from './user';
export * from './invoice';
export * from './invoiceLines';
export * from './reportReconciliationRequest';
export * from './onboardingRequest';
export * from './assignmentTeam';
export * from './subjectMatterExpertTeam';
export * from './businessSupportTeam';
export * from './bulkUploadRequest';
export * from './exchangeMessage';
export * from './usHts';

export const formTransformMap = {
  [ObjectType.PARTY]: transformParty,
  [RecordType.PRODUCT]: transformProduct,
  [RecordType.US_ISF]: transformUsIsf,
  [RecordType.US_CONSUMPTION_ENTRY]: transformUsConsumptionEntry,
  [RecordType.US_POST_SUMMARY_CORRECTION]: transformUsConsumptionEntry,
  [ObjectType.USER]: transformUser,
  [RecordType.INVOICE]: transformInvoice,
  INVOICE_LINES: transformInvoiceLines,
  [RecordType.REPORT_RECONCILIATION_REQUEST]:
    transformReportReconciliationRequest,
  [RecordType.US_IOR_CONTINUOUS_BOND_REQUEST]:
    transformUsIorContinuousBondRequest,
  [RecordType.US_IN_BOND]: transformUsInBond,
  [RecordType.DELIVERY_ORDER]: transformDeliveryOrder,
  [RecordType.SHIPMENT]: transformShipment,
  [RecordType.ASSIGNMENT_TEAM]: transformAssignmentTeam,
  [RecordType.SUBJECT_MATTER_EXPERT_TEAM]: transformSubjectMatterExpertTeam,
  [RecordType.BUSINESS_SUPPORT_TEAM]: transformBusinessSupportTeam,
  [RecordType.BULK_MILESTONE_UPLOAD_REQUEST]: transformBulkUploadRequest,
  [RecordType.BULK_CHARGES_UPLOAD_REQUEST]: transformBulkUploadRequest,
  [RecordType.BULK_COMPLIANCE_UPLOAD_REQUEST]: transformBulkUploadRequest,
  [RecordType.EXCHANGE_MESSAGE]: transformExchangeMessage,
};
